module.exports = __webpack_public_path__ + "e38c62b04f97b5e8b4065f37f7fbd7dc.svg";